
import { useToast as useToastBase, toast as toastBase } from "@/hooks/use-toast";

// Enhanced toast functions
export const useToast = () => {
  const { toast: baseToast, ...rest } = useToastBase();

  const showSuccess = (message: string, description?: string) => {
    baseToast({
      title: "Sucesso",
      description: message,
      variant: "default"
    });
  };

  const showError = (message: string, description?: string) => {
    baseToast({
      title: "Erro",
      description: message,
      variant: "destructive"
    });
  };

  const showWarning = (message: string, description?: string) => {
    baseToast({
      title: "Atenção",
      description: message,
      variant: "default"
    });
  };

  const showInfo = (message: string, description?: string) => {
    baseToast({
      title: "Informação",
      description: message,
      variant: "default"
    });
  };

  return {
    toast: baseToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    ...rest
  };
};

export const toast = toastBase;
